export const CONFIGURATOR_STEPS = {
  BENEFITS: 5,
  COMPLETED: 6,
  DEPARTURE_CITY: 1,
  DEPARTURE_DATE: 3,
  DURATION: 2,
  NO_SELECTION: 0,
  PARTICIPANTS: 4
}

export const INCREMENT = 'inc'
export const DECREMENT = 'dec'

export const DEFAULT_BENEFITS_VALUE = 1
